import React, {useEffect, useState} from 'react'
import Layout from 'common/components/Layout'
import useApi from 'common/hooks/useApi'
import { useParams } from "react-router-dom";
import { Grid } from '@mui/material'
import { momentumLogo } from 'constants/assets.js'
import styled from 'styled-components'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function Pricing() {
  const routeParams = useParams();
  let title = 'Trainers & Teams'
//  const [searchInput, setSearchInput] = useState("")
  const [bio, setBio] = useState("")
  const [profile, setProfile] = useState("")
  const [list, setList] = React.useState([])
  const [list2, setList2] = React.useState([])
  const [planList, setPlanList] = React.useState([])
  const [{ data: plansData = {} }] = useApi('plans/')
  const [{ data: trainersData = {} }] = useApi('public_trainers/')
  const [{ data: subscriptionsData = {} }] =  useApi('subscriptions/')
  const [ ,createSubscription] = useApi(
    { method: 'POST' },
    { manual: true }
  )
  const [{ loading: loadingPortal }, getCustomerPortalUrl] = useApi(
    { method: 'GET' },
    { manual: true }
  )
  const { subscriptions } = subscriptionsData

  async function goToSubscriptionPage() {
      if (!loadingPortal){
          const portalUrl = await getCustomerPortalUrl({
          url:'stripe/customer_portal_url/',
        })
        if (portalUrl?.data?.customerPortalUrl) {
          window.location.href = portalUrl?.data?.customerPortalUrl
        }
      }
  }
  async function handleSubscribed(plan) {
    if(subscriptions?.length > 0) {
      if (subscriptions[0]?.status === 'active' && !subscriptions[0].stripe_subscription_id.includes('cs_live')){
          goToSubscriptionPage()
      } else {
        await createSubscription({
          url:'stripe/checkout_url/',
          data: {
            program_id: plan?.metadata?.program_id,
            trainers: plan?.metadata?.trainers,
            price: plan?.default_price?.id,
            program_name: plan?.metadata?.program_name,
            trial_days: parseInt(plan?.metadata?.trial_days, 10) || 0,
            subscription_type: plan?.default_price?.type
          },
        }).then((response) => {
          if (response){
            window.location.href = response?.data?.checkoutUrl
          }
        })
      }
    } else {
      await createSubscription({
        url:'stripe/checkout_url/',
        data: {
          program_id: plan?.metadata?.program_id,
          trainers: plan?.metadata?.trainers,
          price: plan?.default_price?.id,
          program_name: plan?.metadata?.program_name,
          trial_days: parseInt(plan?.metadata?.trial_days, 10) || 0,
          subscription_type: plan?.default_price?.type
        },
      }).then((response) => {
        if (response){
          window.location.href = response?.data?.checkoutUrl
        }
      })
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const idToSubscribeTo = urlParams.get('subscribe_to')

  useEffect(() => {
    if(idToSubscribeTo?.length > 0 && plansData?.plans){
      const planToSubscribeTo = plansData.plans?.filter(
        (plan) => plan.id === idToSubscribeTo
      )[0];
      if(planToSubscribeTo?.id) {
        if(subscriptionsData){
          goToSubscriptionPage()
        }
        handleSubscribed(planToSubscribeTo);
        urlParams.set('subscribe_to', '');
      }
    }
  }, [idToSubscribeTo, plansData?.plans])

  if (routeParams.id) {
    let selectedTrainer = trainersData?.publicTrainers?.find(user => user.email  === routeParams.id || user.username === routeParams.id);
    if (!selectedTrainer){
      selectedTrainer = trainersData?.newTrainers?.find(user => user.email  === routeParams.id || user.username === routeParams.id);
    }
    title = selectedTrainer?.name
  }

  useEffect(() => {
    if (routeParams.id){
      let selectedTrainer = trainersData?.publicTrainers?.find(user => user.email === routeParams.id || user.username === routeParams.id);
      if (!selectedTrainer){
        selectedTrainer = trainersData?.newTrainers?.find(user => user.email  === routeParams.id || user.username === routeParams.id);
      }
      setBio(selectedTrainer?.biography)
      setProfile(selectedTrainer?.images)
      RegExp.quote = function(str) { return str?.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"); }
      const plans = plansData.plans?.filter(
        (plan) => plan.active && plan.metadata?.trainers?.match(new RegExp(RegExp?.quote(selectedTrainer?.email , "i")))
      )
      setPlanList(plans)

    } else {
      setList(trainersData?.publicTrainers)
      setList2(trainersData?.newTrainers)
    }
  }, [trainersData, plansData, subscriptions, routeParams.id])

    return (
      <Pricing.Stylesheet>
        <Layout>
        {!routeParams?.id && (
          <div className="section" >
            <div>
              <h1>{title}</h1>
            </div>
            <Grid container spacing={5} style={{marginLeft: 50, marginTop: 50}}>
              {list?.map((trainer) => (
                <Grid key={trainer.email} size={3} style={{minWidth: 350}}
                  onClick={() => {window.location.href = `/pricing/${trainer.username}`}}>
                  <div key={trainer.email} className="card text-center">
                    <div className="card-body d-flex flex-column align-items-center">
                      <div className="mb-2">
                        <img src={trainer?.images || momentumLogo} alt="" style={{height: 300, width: 300}}/>
                      </div>
                      <div className="mt-2">
                        <h5>{trainer.name || ''}</h5>
                      </div>
                      <div className="mt-2">
                        <h5>{trainer.plans || '0'} plans</h5>
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
            <div>
              <h1>New Trainers</h1>
            </div>
            <Grid container spacing={5} style={{marginLeft: 50, marginTop: 50, marginBottom: 50}}>
              {list2?.map((trainer) => (
                <Grid key={trainer.email} size={3} style={{minWidth: 350}}
                  onClick={() => {window.location.href = `/pricing/${trainer.email}`}}>
                  <div key={trainer.email} className="card text-center">
                    <div className="card-body d-flex flex-column align-items-center">
                      <div className="mb-2">
                        <img src={trainer?.images || momentumLogo} alt="" style={{height: 300, width: 300}}/>
                      </div>
                      <div className="mt-2">
                        <h5>{trainer.name || ''}</h5>
                      </div>
                      <div className="mt-2">
                        <h5>{trainer.plans || '0'} plans</h5>
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </div>
        )}

        {routeParams?.id && (
          <div className="section" style={{paddingTop: 20}}>
            <div>
              <ArrowBackIcon onClick={() => {window.location.href = `/pricing`}}/>
              <h2>{title}</h2>
            </div>
            <div>
              <h1>Programs</h1>
            </div>
            <Grid container spacing={5} style={{marginTop: 20, marginLeft: 40}}>
              {planList?.map((plan) => (
                <Grid key={plan.id} size={3} style={{minWidth: 325, width: 400}} onClick={() => handleSubscribed(plan)}>
                  <div key={plan.id} className="card text-center">
                    <div className="card-body d-flex flex-column align-items-center" style={{overflow: 'scroll'}}>
                      <div className="mb-2">
                          <img src={plan?.images[0] || momentumLogo} alt="" style={{height: 285, width: 285}}/>
                      </div>
                      <div className="mt-2">
                        <h5>{plan.name || ''}</h5>
                        <span className="display-5" style={{display: 'flex', justifyContent: 'center'}}>
                          {Intl.NumberFormat('en-US', {
                            currency: 'USD',
                            style: 'currency',
                          }).format((plan.default_price?.unit_amount || 0) / 100)}
                          {plan.default_price?.recurring && (
                            <h5 style={{paddingTop: 3}}>
                              / mo
                            </h5>
                          )}
                        </span>
                      </div>
                          <div className="mt-2" style={{height: 150}}>
                            <h5>Includes:</h5>
                            <h5>{plan.description}</h5>
                          </div>

                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
            {routeParams?.id !== 'trainers' && routeParams?.id !== 'teamalberta'
              && routeParams?.id !== 'lloydminster_raiders' &&(
              <div className='mt-4' style={{marginTop: 50}}>
                <h1>Meet your Coach</h1>
              </div>
            )}
            {routeParams?.id === 'teamalberta' &&(
              <div className='mt-4' style={{marginTop: 50}}>
                <h1>Sidekick x Football Alberta</h1>
              </div>
            )}
            {routeParams?.id === 'lloydminster_raiders' &&(
              <div className='mt-4' style={{marginTop: 50}}>
                <h1>Sidekick x Lloydminster Raiders</h1>
              </div>
            )}
            <Grid key='bio' container spacing={10}>
              <Grid size={6} style={{minHeight:300, marginLeft: 40, marginRight: 50, minWidth: 300}}>
                <div>
                  <h4 style={{marginTop: '15vh', marginBottom: '5vh', maxWidth: 800}}>{bio}</h4>
                </div>
              </Grid>
              <Grid key='profile' size={3} style={{height:400, minWidth: 360, marginBottom: '10vh'}}>
                <div>
                  <img src={profile || momentumLogo} alt="" style={{minHeight: 400, maxWidth: '100%', minWidth: 400}}/>
                </div>
              </Grid>
            </Grid>
          </div>
        )}
        </Layout>
    </Pricing.Stylesheet>
  )
}

Pricing.Stylesheet = styled.div`

    h1{
        font-size: 50px;
        font-weight: 400;
        font-family: 'Raleway';
        padding-top: 70px;
        padding-left: 20px;
    }

    h2{
        font-size:40px;
        font-weight: 400;
        font-family: 'Raleway';
        padding-top: 20px;
        padding-left: 20px;
    }
`

export default Pricing
